/*
 * 智能硬件
 */
import React from 'react';
import cn from 'classnames';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import { WrapperBanner } from 'components/product/banner';
import CustomLink from 'components/link';
import style from './index.module.scss';

const IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/hardware/hard/';
const bannerList = [
  {
    bigTitle: '体验可移动全场景灵动视界 ',
    headerImg: `${IMG_PREFIX}img0.jpg`,
    headerImgM: `${IMG_PREFIX}M/imgM0.jpg`,
    bannerInfo: {
      mUrl: `${IMG_PREFIX}M/bg-img0.jpg`,
      pcUrl: `${IMG_PREFIX}bg-img1.jpg`,
      classNames: cn(style.banner),
    },
    title: '一体化4K全场景终端',
    desc: '有型视界，远程办公头等舱',
    link: '/hardware/fullSceneTerminal',
  },
  {
    bigTitle: '打造会议室智慧视讯空间',
    headerImg: `${IMG_PREFIX}img1.jpg`,
    headerImgM: `${IMG_PREFIX}M/imgM2.jpg`,
    bannerInfo: {
      mUrl: `${IMG_PREFIX}M/bg-img1.jpg`,
      pcUrl: `${IMG_PREFIX}bg-img2.jpg`,
      classNames: cn(style.banner),
    },
    title: '小鱼云镜沉浸式远真',
    desc: '真人面对面，天涯若比邻',
    link: '/hardware/cloudMirrorSystem',
  },
  [
    {
      bannerInfo: {
        mUrl: `${IMG_PREFIX}M/bg-img7.jpg`,
        pcUrl: `${IMG_PREFIX}bg-img7.jpg`,
        classNames: cn(style.banner, style.totalBanner),
      },
      title: '大型会议室全4K旗舰终端',
      desc: '纵享至臻大场面',
      link: '/hardware/flagshipTerminal',
    },
    {
      bannerInfo: {
        mUrl: `${IMG_PREFIX}M/bg-img4.jpg`,
        pcUrl: `${IMG_PREFIX}bg-img04.jpg`,
        classNames: cn(style.banner, style.totalBanner),
      },
      title: '中型会议室分体式终端',
      desc: '专业不凡，高性能新体验',
      link: '/hardware/mediumTerminal',
    },
    {
      bannerInfo: {
        mUrl: `${IMG_PREFIX}M/bg-img5.jpg`,
        pcUrl: `${IMG_PREFIX}bg-img5.jpg`,
        classNames: cn(style.banner, style.totalBanner),
      },
      title: '中小型会议室一体式终端',
      desc: '方寸间掌控大视界',
      link: '/hardware/integratedTerminal',
    },
    {
      bannerInfo: {
        mUrl: `${IMG_PREFIX}M/bg-img6.jpg`,
        pcUrl: `${IMG_PREFIX}bg-img6.jpg`,
        classNames: cn(style.banner, style.totalBanner),
      },
      title: '智能会议平板',
      desc: '原生云视频，高效智慧协同',
      link: '/hardware/meetingBoard',
    },
  ],
  {
    bigTitle: '搭建高效指挥调度窗口',
    headerImg: `${IMG_PREFIX}img2.jpg`,
    headerImgM: `${IMG_PREFIX}M/imgM1.jpg`,
    bannerInfo: {
      mUrl: `${IMG_PREFIX}M/bg-img2.jpg`,
      pcUrl: `${IMG_PREFIX}bg-img00.jpg`,
      classNames: cn(style.banner),
    },
    title: '电视墙服务器',
    desc: '统一调度，海量高清画面尽收眼底',
    link: '/hardware/TVwall',
  },
];
const Hard = () => {
  return (
    <Wrapper title="智能硬件" pageKey="hardware" current={0} customClass={style.hardware}>
      {bannerList.map((item: any, index: number) => {
        return Array.isArray(item) ? (
          <div className={style.horizontal} key={index}>
            {item.map(childItem => {
              return (
                <WrapperBanner key={childItem.title} bannerInfo={childItem.bannerInfo}>
                  <div className={style.content}>
                    <div className={style.wrap}>
                      <div className={style.title}>{childItem.title}</div>
                      <div className={style.desc}>{childItem.desc}</div>
                      <CustomLink isNextLink={false} href={childItem.link} className={style.knowMore}>
                        了解更多 &gt;
                      </CustomLink>
                    </div>
                  </div>
                </WrapperBanner>
              );
            })}
          </div>
        ) : (
          <div className={style.contentWrapper}>
            <WrapperBanner key={item.title} bannerInfo={item.bannerInfo}>
              <div className={style.title}>{item.title}</div>
              <div className={style.desc}>{item.desc}</div>
              <CustomLink isNextLink={false} href={item.link} className={style.knowMore}>
                了解更多 &gt;
              </CustomLink>
            </WrapperBanner>
          </div>
        );
      })}
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default Hard;
